<template lang="pug">
section#social_contributions
  .container.custom_container_lg
    .row
      breadcrumb
  .container.custom_container_md.custom_container_news_sm
    .row.i_mt_14.i_mt_md_10
      .col-12.text-center.text-lg-left
        h2.title.bottom_line 社會貢獻
    .row
      .col-12.text-center.text-lg-left.i_mt_10.i_mt_sm_6
        h4 {{ society.area01_Title01 }}
        p.i_body_l.i_mt_4.i_mt_sm_6(v-html="society.area01_Content01")
    .row
      .col-12.text-center.text-lg-left.i_mt_10.i_mt_sm_6
        h4 {{ society.area01_Title02 }}
        p.i_body_l.i_mt_4.i_mt_sm_6(v-html="society.area01_Content02")
    .row.i_mt_6
      .col-12.social_contributions_img
        .img_content.item_1
          img(:src="society.area01_icon01")
          p 深耕社區
        .img_content.item_2
          img(:src="society.area01_icon02")
          p 交通安全
        .img_content.item_3
          img(:src="society.area01_icon03")
          p 弱勢關懷
        .img_content.item_4
          img(:src="society.area01_icon04")
          p 學童教育
        .img_content.item_5
          img(:src="society.area01_icon05")
          p 公益贊助
    .row.social_contributions_label
      .col-6.col-md-3.label
        p 社會重要且高度關注議題
      .col-6.col-md-3.label
        p 結合教育資源並向下扎根
      .col-6.col-md-3.label
        p 接軌業務經驗及專業資源
      .col-6.col-md-3.label
        p 與本業風險管理整合連結
    .row
      .col-12.text-center.text-lg-left.i_mt_6.i_mt_sm_2
        p.i_body_l.i_mt_4.i_mt_sm_6(v-html="society.area01_Content03")
</template>

<script>
import { getSociety } from "@/json/about_us";
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "AboutUsSocialResponsibilitySocialContributions",
  metaInfo() {
    return {
      title: this.society.SEO_Title,
      meta: [{ name: "description", content: this.society.SEO_Description }],
    };
  },
  components: {
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      society: {},
    };
  },
  created() {
    this.getSociety();
  },
  methods: {
    getSociety() {
      getSociety().then((response) => {
        this.society = response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/social_responsibility/common";
@import "@/assets/style/about_us/social_responsibility/social_contributions";
</style>
